var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-viewer"},[_c('el-button',{attrs:{"size":"small","type":"text"},on:{"click":_vm.onPreview}},[_vm._v(_vm._s(_vm.btnText))]),_c('el-image',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"preview",staticClass:"hideImgDiv",attrs:{"preview-src-list":[_vm.url],"src":_vm.url}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }